<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Aufgabenliste</h4>
        </div>
    </div>
    <div class="row marginBottom2Rem" [formGroup]="filterForm">
        <div class="col-sm-3">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suche</mat-label>
                <input type="text" matInput formControlName="searchTerm" placeholder="suchen.."
                    (change)="filterTickets()">
            </mat-form-field>
        </div>
        <div class="col-sm-3">

        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Status </mat-label>
                <mat-select formControlName="filterByTicketStates" multiple="true" (selectionChange)="filterTickets()">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByTicketStates.value != null ">
                            {{this.filterForm.controls.filterByTicketStates.value | translateFilterTicket :
                            'filterByTicketStates'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByTicketStates.value?.length > 1"
                            >
                            (+{{this.filterForm.controls.filterByTicketStates.value.length - 1 }}
                            {{this.filterForm.controls.filterByTicketStates.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of ticketStates" [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>

            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Typ</mat-label>
                <mat-select formControlName="filterByIssueTypes" multiple="true" (selectionChange)="filterTickets()">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByIssueTypes.value != null ">
                            {{this.filterForm.controls.filterByIssueTypes.value | translateFilterTicket :
                            'filterByIssueTypes'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByIssueTypes.value?.length > 1"
                            >
                            (+{{this.filterForm.controls.filterByIssueTypes.value.length - 1 }}
                            {{this.filterForm.controls.filterByIssueTypes.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of issueTypes" [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column w5">
                            {{i+1}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="issueType" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Typ
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip class="primaryChip minh48" selected>
                                    {{element.issueType | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="user" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Ersteller
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span>

                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="worker" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Bearbeiter
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span>

                            </span>
                        </td>
                    </ng-container> -->


                    <ng-container matColumnDef="title" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Betreff
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.title}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="created" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Erstellt
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.created | date:'dd.MM.yyyy HH:mm:ss'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="lastModified" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Letzte Änderung
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.lastModified | date:'dd.MM.yyyy HH:mm:ss'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="state" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element">

                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected>
                                    {{element.state | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Menu
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent" >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="[element.publicId,element.issueType.toString().toLowerCase()]">
                                    <span>Ansehen</span>
                                </button>
                             <button mat-menu-item  [disabled]="element.state != 'CLOSED'" (click)="changeTicketState(element, 'NEW')">
                                    <span>Ticket öffnen</span>
                                </button>
                                <button mat-menu-item [disabled]="element.state != 'NEW'" (click)="changeTicketState(element, 'CLOSED')">
                                    <span>Ticket schließen</span>
                                </button> 
                                <!-- <button mat-menu-item (click)="getTicketAsXLS(element.publicId)">
                                    <span>Ticket runterladen (XLS)</span>
                                </button> -->
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge
                    gefunden</span>
                <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size"
                    [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[12, 24, 36, 48]"
                    *ngIf="page">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>

<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>